module.exports = __webpack_public_path__ + "img/final-scene.63e7b6ee.png";